/**
 * Analytics Portal V1 — metric-level unavailable / partial state (Phase 9, C2 + §12.7).
 *
 * Renders the server's own `notice` **in place of the number** — never a zero, never a dash,
 * never a substituted value. When the API supplies `range_suggestion`, the shortcut jumps to
 * the supported range instead of asking the reader to guess it.
 */
import React from "react";
import { CalendarRange, Info } from "lucide-react";
import { Button } from "@/components/ui/button";

export const MetricUnavailable = ({ metricKey, metric, rangeSuggestion, onUseSupportedRange }) => {
  const notice = metric?.notice
    || "This metric isn't available for the selected period.";
  return (
    <div className="mt-1 space-y-2" data-testid={`analytics-metric-unavailable-${metricKey}`}>
      <p className="flex items-start gap-1.5 text-xs leading-snug text-muted-foreground">
        <Info className="mt-0.5 h-3.5 w-3.5 shrink-0" aria-hidden="true" />
        <span>{notice}</span>
      </p>
      {metric?.partial && rangeSuggestion && onUseSupportedRange && (
        <Button
          variant="secondary"
          size="sm"
          className="h-7 px-2 text-xs"
          onClick={() => onUseSupportedRange(rangeSuggestion)}
          data-testid={`analytics-metric-range-shortcut-${metricKey}`}
        >
          <CalendarRange className="mr-1.5 h-3.5 w-3.5" aria-hidden="true" />
          {rangeSuggestion.label || "View supported range"}
        </Button>
      )}
    </div>
  );
};
